import logo from "./logo.svg";
import "./App.css";
import Index from "./components/Index";
import { BrowserRouter } from "react-router-dom";

function App() {
	return (
		<BrowserRouter>
			<div className="App">
				<Index />
			</div>
		</BrowserRouter>
	);
}

export default App;
